import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { imgUrl } from '../../common/utilities/ImgUrl';
import { cssClass, flexRowStyle, textEllipsis } from '../../style';

const cssPrefix = 'FlowTags';

const rootClass = cssClass(cssPrefix, 'root', flexRowStyle, {
  marginTop: CommonStyles.Sizes.DefaultSpace
});

const tagsContainer = cssClass(cssPrefix, 'tags', flexRowStyle, {
  flexWrap: 'wrap',
});

export const tagClass = cssClass(cssPrefix, 'tag', textEllipsis, {
  maxWidth: 240
});

const headerClass = cssClass(cssPrefix, 'header', {
  fontWeight: 'normal',
  fontSize: CommonStyles.Sizes.HeaderFontSize,
  marginRight: CommonStyles.Sizes.MediumSpace,
});

export const buttonClass = cssClass(cssPrefix, 'button', {
  marginLeft: CommonStyles.Sizes.DefaultSpace,
  minWidth: CommonStyles.Sizes.NormalIconSize,
  height: CommonStyles.Sizes.NormalIconSize,
  backgroundImage: imgUrl('edit_small_normal.svg'),
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  $nest: {
    '&:hover': {
      backgroundColor: CommonStyles.Colors.Grey230,
      backgroundImage: imgUrl('edit_small_hover.svg')
    }
  }
});

const separator = cssClass(cssPrefix, 'separator', {
  marginRight: CommonStyles.Sizes.SmallSpace
});

export type FlowTagsProps = {
  readonly editTagAllowed: boolean;
  readonly editTags: () => void;
  readonly siteUrls: SiteUrls;
  readonly tags: ReadonlyArray<string>;
};

export class FlowTags extends React.PureComponent<FlowTagsProps> {

  private renderTags(): JSX.Element[] | JSX.Element {
    const tagLinks: JSX.Element[] = [];
    this.props.tags.forEach((tag) => {
      tagLinks.push(<a className={tagClass} href={this.props.siteUrls.flowsWithTagUrl(tag)} title={tag} key={tag}>{tag}</a>);
      tagLinks.push(<span className={separator} key={tag + 'separator'}>,</span>);
    });
    tagLinks.pop();
    return tagLinks.length > 0 ? tagLinks : <div>{Messages.flowOverviewNoTags()}</div>;
  }

  public render() {
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return (
      <div className={rootClass}>
        <div className={tagsContainer}>
          <div className={headerClass}>{Messages.tags()}</div>
          {this.renderTags()}
        </div>
        { this.props.editTagAllowed ?
          <div className={buttonClass} title={Messages.editTags()} onClick={this.props.editTags}/> : null }
      </div>
    );
  }
}
